let moment = require('moment');
/**
 * @class AppointmentService
 */
function AppointmentService($q, $log, appointmentBackend, $root) {
    var self = this;


    /**
     * Retrieves all appointments.
     *
     * This function is used to fetch a list of all appointments available
     * in the system. The appointments may include details such as date, time,
     * participants, and additional metadata based on the implementation.
     *
     * @returns {Promise<Array>} A promise that resolves to an array of all appointments.
     * The individual structure of appointments is determined by the underlying data model.
     */
    self.getAllAppointments = function(filters) {
        // console.log(filters);
        return appointmentBackend.getAllAppointments(filters)
        .catch(function(error) {
            $log.error('Erreur lors de la récupération des rendez-vous:', error);
            return Promise.reject(error);
        });
    };

    self.updateAppointmentStatus = function(appointment) {
        return appointmentBackend.updateAppointmentStatus(appointment);
    }

    /**
     * get the store's appointments
     * @return {promise}
     * @param storeId
     */
    self.getAppointments = function (storeId) {
        var d = $q.defer();
        appointmentBackend.getAppointments(storeId).then(function(appointments) {
            appointments.forEach(function(appointment) {
                appointment.start_date = moment(appointment.start_date, 'YYYY-MM-DD hh:mm:ss').format('DD/MM/YYYY');
                appointment.contact_date = appointment.contact_date ?  moment(appointment.contact_date, 'YYYY-MM-DD hh:mm:ss').format('DD/MM/YYYY') : null;
            });

            d.resolve(appointments);
        }, d.reject.bind(d));
        return d.promise;
    };

    /**
     * Get appointment purposes
     * @return {Promise}
     */
    self.getAppointmentPurposes = function getAppointmentPurposes(source) {
        var d = $q.defer();

        if ($root.appointmentPurposes && $root.appointmentPurposes.length) {
            d.resolve($root.appointmentPurposes);
        }
        else {
            appointmentBackend.getAppointmentPurposes(source).then(function(appointmentPurposes) {
                $root.appointmentPurposes = appointmentPurposes;
                d.resolve($root.appointmentPurposes);
            }, d.reject.bind(d));
        }
        return d.promise;
    };

    /**
     * Get appointment durations
     * @return {Promise}
     */
    self.getAppointmentDurations = function getAppointmentDurations() {
        var d = $q.defer();

        if ($root.appointmentDurations && $root.appointmentDurations.length) {
            d.resolve($root.appointmentDurations);
        }
        else {
            appointmentBackend.getAppointmentDurations().then(function(appointmentDurations) {
                $root.appointmentDurations = appointmentDurations;
                d.resolve($root.appointmentDurations);
            }, d.reject.bind(d));
        }
        return d.promise;
    };

    /**
     * Get appointment sources
     * @return {Promise}
     */
    self.getAppointmentSources = function getAppointmentSources() {
        var d = $q.defer();

        if ($root.appointmentSources && $root.appointmentSources.length) {
            d.resolve($root.appointmentSources);
        }
        else {
            appointmentBackend.getAppointmentSources().then(function(appointmentSources) {
                $root.appointmentSources = appointmentSources;
                d.resolve($root.appointmentSources);
            }, d.reject.bind(d));
        }
        return d.promise;
    };

    /**
     * Get appointment provenances
     * @return {Promise}
     */
    self.getAppointmentProvenances = function () {
        var d = $q.defer();

        if ($root.appointmentProvenances && $root.appointmentProvenances.length) {
            d.resolve($root.appointmentProvenances);
        }
        else {
            appointmentBackend.getAppointmentProvenances().then(function(appointmentProvenances) {
                $root.appointmentProvenances = appointmentProvenances;
                d.resolve($root.appointmentProvenances);
            }, d.reject.bind(d));
        }
        return d.promise;
    };

    /**
     * Add a new appointment
     * @param {Object} store
     * @param {Object} appointment : {
     *   appointmentDuration,
     *   appointmentPurpose,
     *   comment,
     *   date
     * }
     * @param {boolean} isTelepro
     * @param {boolean} isCsd
     * @return {Promise}
     */
    self.addNewAppointment = function addNewAppointment(store, appointment, isTelepro, isCsd){
        let _date, _data;
        if(appointment.startDate !== undefined && moment(appointment.startDate).isValid()){
            _date = moment(appointment.startDate);
        }else{
            _date = moment(appointment.date).isValid() ? moment(appointment.date).format('YYYY-MM-DD') : moment().format('YYYY-MM-DD');
        }
        _data = {
            appointment : {
                purpose_designation : appointment.purposeDesignation || null,
                appointement_purpose_id : appointment.appointmentPurpose !== undefined ? appointment.appointmentPurpose : null,
                appointment_duration_id : appointment.appointmentDuration !== undefined ? appointment.appointmentDuration : null,
                appointment_provenance_id : appointment.appointmentProvenance !== undefined ? appointment.appointmentProvenance : null,
                appointment_source_id : appointment.appointmentSource !== undefined ? appointment.appointmentSource : null,
                comment                 : appointment.comment || '',
                start_date              : _date,
                end_date                : appointment.endDate !== undefined && moment(appointment.endDate).isValid() ? moment(appointment.endDate) : null,
            },
            contact : {
                code_postal        : store.contact.code_postal,
                adresse            : store.contact.adresse,
                complement_adresse : store.contact.complement_adresse,
                ville              : store.contact.ville,
                telephone_fixe     : store.contact.telephone_fixe,
                telephone_portable : store.contact.telephone_portable,
                numero_fax         : store.contact.numero_fax,
                departement        : store.contact.departement,
            },
            customers    : store.customers,
            responsable_commercial : store.responsable_commercial,
            activities : store.activities,
            qualification : store.qualification,
            etat_magasin : store.etat_magasin,
            user         : $root.user,
            isTelepro    : isTelepro,
            isCsd  : isCsd
        }
        if(isTelepro || isCsd){
            _data.appointment.user_id_ref = appointment.user;
            _data.appointment.create_call_id = null;
            if(appointment.appointmentPurpose === '4'){
                _data.appointment.appointment_source_id = appointment.appointmentSource;
                _data.appointment.stage = appointment.appointmentStage;
            }
        }
        return appointmentBackend.addNewAppointment(store.identifiant_magasin, _data).then(function (appointment) {
            appointment.start_date = moment(appointment.start_date, 'YYYY-MM-DD hh:mm:ss').format('DD/MM/YYYY');
            if(appointment.end_date !== null){
                appointment.end_date = moment(appointment.end_date, 'YYYY-MM-DD hh:mm:ss').format('DD/MM/YYYY');
            }
            return appointment;
        });
    };

    return self;
}
AppointmentService.$inject = ['$q', '$log', 'appointmentBackend', '$rootScope'];

angular.module('app.prospection.store.appointmentService', []).factory('appointmentService', AppointmentService);